import { createSelector } from 'reselect';
import { WebInterfaceBaseState } from '../../../common/base/state';
import { List } from 'immutable';
import { IRecentAppItem, RecentAppItem } from '../entities/widgets/model/types/IRecentAppItem';

const getRecentAppsDataSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.recentApps.data;

export const getRecentAppsData = createSelector(
	[getRecentAppsDataSelector],
	(recentApps: List<RecentAppItem>): Array<IRecentAppItem> =>
		recentApps.map(app => app.toJS()).toJS()
);

const getRecentAppsLoadingSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.recentApps.loading;

export const getRecentAppsLoading = createSelector(
	[getRecentAppsLoadingSelector],
	(loading: boolean): boolean => loading
);

const getRecentAppsIsPinningSelector = (state: WebInterfaceBaseState) =>
	state.modules.dashboard.widgets.recentApps.isPinning;

export const getRecentAppsIsPinning = createSelector(
	[getRecentAppsIsPinningSelector],
	(isPinning: boolean): boolean => isPinning
);
